import { ENDPOINTS } from "@constants";
import AbstractService from "./AbstractService";
import NexusService from "./NexusService";
import FeatureFlagService from "./FeatureFlagService";

export default class OrganizationOfficerConstraintsService extends AbstractService {
	static endpoint = ENDPOINTS.agencyRestrictions;

	static organizationOfficerConstraintsApi = NexusService.organizationOfficerConstraintsApi;

	static apiCoreEndpointsFeature = "use_api_core_endpoints_organization_officer_constraints";

	static getAgencyRestrictions() {
		if (FeatureFlagService.isEnabled(this.apiCoreEndpointsFeature)) {
			return this.organizationOfficerConstraintsApi
				.getOrganizationOfficerConstraints()
				.then(response => {
					const apiResponse = {
						data: response,
					};
					return apiResponse;
				});
		}

		return this.get({
			endpoint: this.endpoint,
		});
	}

	static saveAgencyRestrictions(data) {
		if (FeatureFlagService.isEnabled(this.apiCoreEndpointsFeature)) {
			const updateReq = {
				organizationOfficerConstraintsUpdatePayload: {
					RequiredJurisdictions: data.RequiredJurisdictions,
					ExcludedJurisdictions: data.ExcludedJurisdictions,
				},
			};

			return this.organizationOfficerConstraintsApi
				.updateOrganizationOfficerConstraints(updateReq)
				.then(response => ({ data: response }));
		}

		return this.post({
			endpoint: this.endpoint,
			data,
		});
	}
}
